import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, useToken } from '@chakra-ui/react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';

import { DropdownOption } from '../../DropdownInput/typings';

const SearchDropdownIndicator = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  testId,
  ...props
}: DropdownIndicatorProps<Option, IsMulti, Group> & { testId?: string }) => {
  const [gray800] = useToken('colors', ['gray.800']);

  return (
    <Box paddingTop='0' paddingBottom='0' data-testid={testId || 'search'} height='100%' alignContent={'center'}>
      <components.DropdownIndicator {...props}>
        <ChevronDownIcon color={gray800} boxSize={5} />
      </components.DropdownIndicator>
    </Box>
  );
};

export default SearchDropdownIndicator;
